"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeywordSearchScoreResponseSchema = exports.KeywordSearchScoreSchema = exports.KeywordAppRanksResponseSchema = exports.KeywordAppRankListResponseSchema = exports.KeywordAppRankSchema = exports.ApplyzerResponse = void 0;
const typebox_1 = require("@sinclair/typebox");
const core_1 = require("../../../core");
function ApplyzerResponse(dataSchema) {
    return typebox_1.Type.Object({
        response: dataSchema,
        message: typebox_1.Type.String(),
    });
}
exports.ApplyzerResponse = ApplyzerResponse;
exports.KeywordAppRankSchema = (0, core_1.StrictObject)({
    appid: typebox_1.Type.String(),
    rank: typebox_1.Type.Integer(),
});
exports.KeywordAppRankListResponseSchema = (0, core_1.StrictObject)({
    date: typebox_1.Type.String(),
    results: typebox_1.Type.Array(exports.KeywordAppRankSchema),
});
exports.KeywordAppRanksResponseSchema = ApplyzerResponse(exports.KeywordAppRankListResponseSchema);
exports.KeywordSearchScoreSchema = (0, core_1.StrictObject)({
    date: typebox_1.Type.String(),
    score: typebox_1.Type.Integer(),
});
exports.KeywordSearchScoreResponseSchema = ApplyzerResponse(exports.KeywordSearchScoreSchema);
